import { LitElement } from '~/lib/bn-lit-element';
import { html } from '../../utility/lit-entity';

export const PAYLOAD_TYPE = {
  RUN: 0,
  SETUP: 1,
  DEV: 2,
  TOWER_SEARCH: 3,
  FACTORY: 4,
};

class DeviceEventPayloadType extends LitElement {
  static get properties() {
    return {
      payloadType: { type: Number, attribute: 'payload-type' },
    };
  }

  render() {
    switch (this.payloadType) {
    case PAYLOAD_TYPE.RUN:
      return html`RUN`;
    case PAYLOAD_TYPE.SETUP:
      return html`SETUP`;
    case PAYLOAD_TYPE.DEV:
      return html`DEV`;
    case PAYLOAD_TYPE.TOWER_SEARCH:
      return html`TOWER SEARCH`;
    case PAYLOAD_TYPE.FACTORY:
      return html`FACTORY`;
    default:
      return html`???`;
    }
  }
}

window.customElements.define('device-event-payload-type', DeviceEventPayloadType);
